"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var BrowserReadiness = exports.BrowserReadiness = function BrowserReadiness(_ref) {
  var status = _ref.status,
    hideBottomBorder = _ref.hideBottomBorder,
    presenterId = _ref.presenterId,
    messageBody = _ref.messageBody,
    statusText = _ref.statusText;
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Browser",
    status: status,
    statusText: statusText,
    onRetry: null,
    hideBottomBorder: hideBottomBorder,
    failedText: "You are using an unsupported browser",
    presenterId: presenterId
  }, messageBody ? /*#__PURE__*/_react["default"].createElement("p", null, messageBody) : /*#__PURE__*/_react["default"].createElement("p", null, "To join Studio you must use Google Chrome or Microsoft Edge on a computer"));
};
BrowserReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  messageBody: _propTypes.string,
  statusText: _propTypes.string,
  presenterId: _propTypes.string,
  hideBottomBorder: _propTypes.bool
};